/**
 * Recipes the signed-in user favorited (V2 browse cards).
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaStar } from 'react-icons/fa';
import { communityRecipesService } from '../services/communityRecipesService';
import { CommunityRecipesPageShell } from './CommunityRecipesPageShell';
import { proteinLabel } from '../campRecipesFilters';
import './camp-essentials-shell.css';
import './camp-recipes-shell.css';

export function CommunityRecipeFavorites() {
  const navigate = useNavigate();
  const [recipes, setRecipes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    communityRecipesService
      .listFavorites()
      .then((data) => {
        if (!cancelled) setRecipes(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setError('Could not load favorites.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <CommunityRecipesPageShell
      title="Favorite recipes"
      subtitle="Recipes you saved from the community"
      testId="camp-recipes-favorites"
    >
      {loading ? <p className="camp-recipes-page__loading">Loading favorites…</p> : null}
      {error ? <p className="camp-recipes-page__error">{error}</p> : null}
      {!loading && !error && recipes.length === 0 ? (
        <p className="camp-recipes-empty">
          No favorites yet. Open a recipe and tap Favorite.
        </p>
      ) : null}
      {!loading && !error && recipes.length > 0 ? (
        <div className="camp-recipes-browse__grid camp-recipes-browse__grid--list">
          {recipes.map((r) => (
            <button
              key={r.id}
              type="button"
              className="camp-recipes-card camp-recipes-card--list"
              onClick={() => navigate(`/camp-essentials/recipes/${r.id}`)}
            >
              <div className="camp-recipes-card__media">
                {r.thumbnail_url ? (
                  <img src={r.thumbnail_url} alt="" />
                ) : (
                  <div className="camp-recipes-card__media-placeholder" aria-hidden="true" />
                )}
              </div>
              <div className="camp-recipes-card__body">
                <h3 className="camp-recipes-card__title">{r.title}</h3>
                {r.description ? (
                  <p className="camp-recipes-card__desc">{r.description}</p>
                ) : null}
                <div className="camp-recipes-card__meta">
                  <span className="camp-recipes-card__source">
                    {r.source === 'curated' ? 'Curated' : 'Community'}
                    {r.main_protein ? ` · ${proteinLabel(r.main_protein)}` : ''}
                  </span>
                  {r.avg_stars != null ? (
                    <span>
                      <FaStar aria-hidden="true" /> {r.avg_stars}
                    </span>
                  ) : null}
                </div>
              </div>
            </button>
          ))}
        </div>
      ) : null}
    </CommunityRecipesPageShell>
  );
}
